(function () {
  'use strict';

  function isItalyDestination() {
    return document.documentElement.getAttribute('data-pmy-destination') === 'italy';
  }

  function isIconMedia(el) {
    if (!el) return false;
    var src = ((el.currentSrc || el.src || '') + '').toLowerCase();
    var alt = ((el.alt || '') + '').toLowerCase();
    var text = src + ' ' + alt;
    return /(?:adult[-_ ]?icon|group[-_ ]?icon|private[-_ ]?icon|(?:^|[\/_-])icon(?:[\/_\-.]|$)|\/icons?\/)/i.test(text);
  }

  function addGallerySizingStyle() {
    if (document.getElementById('pmy-gallery-sizing-fix')) return;
    var style = document.createElement('style');
    style.id = 'pmy-gallery-sizing-fix';
    style.textContent = [
      '.collection-gallery-main{height:460px!important;}',
      '.collection-gallery-slide{height:100%!important;overflow:hidden!important;}',
      '.collection-gallery-slide img{width:100%!important;height:100%!important;object-fit:cover!important;object-position:center!important;display:block!important;}',
      '.collection-gallery-thumb{width:120px!important;height:84px!important;object-fit:cover!important;object-position:center!important;flex:0 0 84px!important;}',
      '.modal-media-slider,.modal-slides-container,.modal-slide{height:100%!important;}',
      'img.modal-slide{width:100%!important;object-fit:cover!important;object-position:center!important;}',
      '.modal-thumb{object-fit:cover!important;object-position:center!important;}',
      '@media(max-width:767px){.collection-gallery-main{height:260px!important;}.collection-gallery-thumb{width:96px!important;height:72px!important;flex:0 0 96px!important;}}'
    ].join('');
    document.head.appendChild(style);
  }

  function normalizeProductModalMedia() {
    document.querySelectorAll('.modal-media-slider[id^="slider-"]').forEach(function (slider) {
      var container = slider.querySelector('.modal-slides-container');
      if (!container) return;
      var productId = slider.id.replace('slider-', '');
      var thumbsBox = document.getElementById('thumbs-' + productId);
      var slides = Array.prototype.slice.call(container.querySelectorAll('.modal-slide'));
      var thumbs = thumbsBox ? Array.prototype.slice.call(thumbsBox.querySelectorAll('.modal-thumb')) : [];
      var removeIndexes = [];

      slides.forEach(function (slide, index) {
        if (slide.tagName === 'IMG' && (isIconMedia(slide) || isIconMedia(thumbs[index]))) removeIndexes.push(index);
      });

      for (var i = removeIndexes.length - 1; i >= 0; i--) {
        var idx = removeIndexes[i];
        if (slides[idx] && slides[idx].parentNode) slides[idx].parentNode.removeChild(slides[idx]);
        if (thumbs[idx] && thumbs[idx].parentNode) thumbs[idx].parentNode.removeChild(thumbs[idx]);
      }

      if (thumbsBox) {
        Array.prototype.forEach.call(thumbsBox.querySelectorAll('.modal-thumb'), function (thumb, index) {
          thumb.classList.toggle('active', index === 0);
          thumb.setAttribute('onclick', "setSlide('" + slider.id + "', " + index + ")");
        });
      }

      slider.setAttribute('data-current', '0');
      container.style.transform = 'translateX(0%)';
      slider.removeAttribute('data-init');
      var dots = slider.querySelector('.modal-slider-dots');
      if (dots) dots.innerHTML = '';
    });
  }

  function panelItems(panel) {
    if (!panel) return [];
    var items = [];
    panel.querySelectorAll('.product-card[data-bs-target^="#modal-tour-"]').forEach(function (card) {
      var target = card.getAttribute('data-bs-target');
      var modal = target ? document.querySelector(target) : null;
      var titleEl = card.querySelector('h5');
      var title = titleEl ? titleEl.textContent.trim() : '';
      if (!modal) return;
      modal.querySelectorAll('.modal-slide').forEach(function (media) {
        if (media.tagName !== 'IMG' || isIconMedia(media)) return;
        var src = media.currentSrc || media.src;
        if (!src) return;
        items.push({ src: src, title: title });
      });
    });
    return items;
  }

  function uniqueItems(items) {
    var seen = Object.create(null);
    return items.filter(function (item) {
      var key = item.src.split('?')[0];
      if (seen[key]) return false;
      seen[key] = true;
      return true;
    });
  }

  function shuffle(items) {
    var a = items.slice();
    for (var i = a.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = a[i]; a[i] = a[j]; a[j] = t;
    }
    return a;
  }

  function getPortugalGalleryItems(key) {
    var stack = document.querySelector('#tours .modalidade-stack');
    if (!stack) return [];
    var items = [];

    if (key && key !== 'all') {
      var panel = stack.querySelector('.modalidade-panel[data-mod-panel="' + key + '"]:not(.pmy-italy-home)');
      items = panelItems(panel);
    } else {
      stack.querySelectorAll('.modalidade-panel:not(.pmy-italy-home)').forEach(function (panel) {
        items = items.concat(panelItems(panel));
      });
      items = shuffle(items);
    }

    return uniqueItems(items);
  }

  function setPortugalGallerySlide(slider, index) {
    if (!slider) return;
    var slides = slider.querySelectorAll('.collection-gallery-slide');
    var thumbs = slider.querySelectorAll('.collection-gallery-thumb');
    if (!slides.length) return;
    if (index < 0) index = slides.length - 1;
    if (index >= slides.length) index = 0;
    slider.setAttribute('data-current', String(index));
    var track = slider.querySelector('.collection-gallery-slides');
    if (track) track.style.transform = 'translateX(-' + (index * 100) + '%)';
    Array.prototype.forEach.call(thumbs, function (thumb, i) {
      thumb.classList.toggle('active', i === index);
    });
    if (thumbs[index]) thumbs[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
  }

  function renderPortugalGallery(items) {
    var slider = document.querySelector('#tours [id^="col-gallery-"]');
    if (!slider) return false;
    var slidesBox = slider.querySelector('.collection-gallery-slides');
    var thumbsBox = slider.querySelector('.collection-gallery-thumbs');
    if (!slidesBox || !thumbsBox) return false;

    slidesBox.innerHTML = '';
    thumbsBox.innerHTML = '';
    slider.setAttribute('data-current', '0');
    slidesBox.style.transform = 'translateX(0%)';

    if (!items.length) return false;

    items.forEach(function (item, index) {
      var slide = document.createElement('div');
      slide.className = 'collection-gallery-slide';

      var caption = document.createElement('span');
      caption.className = 'collection-gallery-caption';
      caption.textContent = item.title || '';

      var image = document.createElement('img');
      image.src = item.src;
      image.alt = item.title || '';
      image.loading = 'lazy';
      image.decoding = 'async';

      slide.appendChild(caption);
      slide.appendChild(image);
      slidesBox.appendChild(slide);

      var thumb = document.createElement('img');
      thumb.className = 'collection-gallery-thumb' + (index === 0 ? ' active' : '');
      thumb.src = item.src;
      thumb.alt = item.title || '';
      thumb.loading = 'lazy';
      thumb.decoding = 'async';
      thumb.addEventListener('click', function () { setPortugalGallerySlide(slider, index); });
      thumbsBox.appendChild(thumb);
    });

    slider.style.display = '';
    var prev = slider.querySelector('.collection-gallery-prev');
    var next = slider.querySelector('.collection-gallery-next');
    var hideControls = items.length <= 1;
    if (prev) prev.style.display = hideControls ? 'none' : '';
    if (next) next.style.display = hideControls ? 'none' : '';
    thumbsBox.style.display = hideControls ? 'none' : '';
    return true;
  }

  function installPortugalGalleryOverride() {
    var current = window.showCollectionGallery;
    if (typeof current !== 'function' || current.__pmyPortugalFullGallery) return false;

    function fullPortugalGallery(key) {
      if (isItalyDestination()) return current.apply(this, arguments);
      normalizeProductModalMedia();
      var items = getPortugalGalleryItems(key || 'all');
      if (renderPortugalGallery(items)) return;
      return current.apply(this, arguments);
    }

    fullPortugalGallery.__pmyPortugalFullGallery = true;
    fullPortugalGallery.__pmyPreviousGallery = current;
    window.showCollectionGallery = fullPortugalGallery;
    return true;
  }

  function initPortugalGalleryFix() {
    if (!document.getElementById('tours')) return;
    addGallerySizingStyle();
    normalizeProductModalMedia();

    var tries = 0;
    var timer = window.setInterval(function () {
      tries += 1;
      if (installPortugalGalleryOverride() || tries >= 20) {
        window.clearInterval(timer);
        if (!isItalyDestination() && typeof window.showCollectionGallery === 'function') {
          window.showCollectionGallery('all');
        }
      }
    }, 100);

    window.addEventListener('pmy:destination-change', function (event) {
      if (event && event.detail && event.detail.destination === 'portugal') {
        window.setTimeout(function () {
          installPortugalGalleryOverride();
          normalizeProductModalMedia();
          if (typeof window.showCollectionGallery === 'function') window.showCollectionGallery('all');
        }, 0);
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initPortugalGalleryFix, { once: true });
  else initPortugalGalleryFix();
})();
